// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__rNib5","label":"Section_label__3NLHQ","contentWrap":"Section_contentWrap__1ppWX","footer":"Section_footer__3Dx36","footerInner":"Section_footerInner__3Q5PN"};